import React, { useState, PureComponent, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Carousel from "react-bootstrap/Carousel";
import "../App.css";
import Header from "./header";
import SideNav from "./sidenav";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { getStore } from "../redux/actions/storeAction";
const initialState = {
  show: false,
};

const MyStore = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { storeData } = useSelector((state) => state.store);
  // console.log("storeData.......>", storeData)

  useEffect(() => {
    dispatch(getStore({}));
  }, []);

  useEffect(() => {
    if (storeData.status == 505) {
      navigate("/");
      toast.error(storeData.message, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }, [storeData]);

  const [iState, updateState] = useState(initialState);
  const { AddModal } = iState;

  const handleAddClose = () => {
    updateState({ ...iState, AddModal: false });
  };
  const handleAddShow = () => {
    updateState({ ...iState, AddModal: true });
  };

  const handleDetail = (id) => {
    window.localStorage.setItem("storeId", JSON.stringify(id));
  };

  return (
    <div>
      <Header />
      <SideNav />
      <div class="WrapperArea">
        <div class="WrapperBox">
          <div class="TitleBox">
            <div>
              <h4 class="Title">Store profile setup</h4>
            </div>
          </div>
          {storeData ? (
            <>
              <div className="Small-Wrapper">
                <span className="EditDetails">
                  <Link
                    to="/edit-my-store"
                    onClick={() => handleDetail(storeData?.data?._id)}
                  >
                    <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                  </Link>
                </span>
                <div className="StoreBaner">
                  <Carousel>
                    {storeData?.data?.banner?.length > 0 &&
                      storeData?.data?.banner?.map((item, i) => {
                        return (
                          <Carousel.Item>
                            <img src={item} width="100%" height="500px" />
                          </Carousel.Item>
                        );
                      })}
                  </Carousel>
                </div>
                <div className="StockDetails">
                  <div class="DetailsInner">
                    <div class="RightDetails">
                      <figure>
                        {/* <img src={storeData?.data?.logo} /> */}
                      </figure>
                      <article>
                        <h4>{storeData?.data?.storeName}</h4>
                      </article>
                    </div>
                    {/* <div class="LeftDetails">
                      <aside>
                        <p>Operational Hours</p>
                        <h5 className="Yellow">{`${storeData?.data?.openTime} ${storeData?.data?.openTimePeriod} to ${storeData?.data?.closeTime} ${storeData?.data?.closeTimePeriod}`}</h5>
                      </aside>
                    </div> */}
                  </div>
                  <div className="Text">
                    <h6>
                      <strong>{storeData?.data?.address} </strong>
                    </h6>

                    <h6>
                      Serving Category:{" "}
                      <strong>
                        {storeData?.data?.storeCategory?.category_name}
                      </strong>
                    </h6>
                  </div>
                     <div class="col-sm-8">
                  <div class="form-group">
                    <label>Operational Hours</label>
                    <div className="DosageBox">
                      <div className="row">
                        {storeData?.data?.workingDays?.map((day, index) => (
                          <div className="col-12 mb-3" key={index}>
                            <div className="row align-items-center">
                              {/* Day name + toggle */}

                              <div className="col-sm-2 d-flex align-items-center justify-content-between">
                                <strong>{day.name}</strong>
                              </div>
                              {/* Opening time */}
                              <div className="col-sm-5">
                                <div className="form-group">
                                  <label>Opening time</label>
                                  <div className="TimeMain">
                                    <div className="HoverBox">
                                      <p>{day.openHour} :</p>
                                    </div>

                                    <div className="MinutesBox">
                                      <p>{day?.openMinute}</p>
                                    </div>

                                    <div className="TimeBox">
                                      <p> {day?.openPeriod}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Closing time */}
                              <div className="col-sm-5">
                                <div className="form-group">
                                  <label>Closing time</label>
                                  <div className="TimeMain">
                                    <div className="HoverBox">
                                      <p>{day.closeHour} :</p>
                                    </div>

                                    <div className="MinutesBox">
                                      <p>{day.closeMinute}</p>
                                    </div>

                                    <div className="TimeBox">
                                      <p>{day.closePeriod}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                  <div className="Text">
                    <h6>
                      <strong>{storeData?.data?.overAllDiscount}% OFF </strong>
                      <span className="Green">
                        (on min purchase of SAR {storeData?.data?.minOrderValue}
                        )
                      </span>
                    </h6>
                    <h6>
                      Serving Type:
                      {storeData?.data?.serviceType?.length > 0 &&
                        storeData?.data?.serviceType?.map((item, index) => {
                         
                          return <>{<strong> {item}</strong>}</>;
                        })}
                    </h6>
                  </div>
                  {/* <div className="Text flex-row-reverse">
                                <h6>Serving Sub-Category: <strong>Chinese, Italian , Mexican,American</strong></h6>
                            </div> */}
                </div>
                <div className="StoreText">
                  <h5>Description</h5>
                  <p>{storeData?.data?.description}</p>
                </div>
                <div class="CategoryDetails">
                  <ul>
                    <li>
                      <span>Mobile no.: {storeData?.data?.mobileNumber}</span>
                    </li>
                    <li>
                      <span>Email: {storeData?.data?.email}</span>
                    </li>
                    <li>
                      <span>Address: {storeData?.data?.address}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </>
          ) : (
            <>
              {" "}
              <h2 className="MainMessage">Data not Found !!!</h2>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
export default MyStore;
